export default "__VITE_ASSET__cd8e2b44__"